import _ from "lodash";
import i18n from "../i18n";
import {
  CLEAR_FORUM,
  FORUM_ARCHIVE_INITIALIZATION,
  FORUM_CANCEL_POST,
  FORUM_DELETE_POST,
  FORUM_DO_ARCHIVE,
  FORUM_INITIALIZATION,
  FORUM_INSERT,
  FORUM_LOAD_MORE,
  FORUM_ON_CHANGE_STATE,
  FORUM_RELEVANT,
  FORUM_REMOVE_ARCHIVE,
  FORUM_SELECT_FOR_EDIT_POST,
  FORUM_SINGLE_INITIALIZATION,
  getEnded,
  getFailed,
  getStarted,
  getSucceeded,
  IS_UNSAVED,
  ON_CHANGE_ARCHIVE_FILTERS,
  ON_CHANGE_FORUM_FILTERS,
  RE_GET_FORUM_FILTERS,
  USER_LANG,
  ON_SEARCH_POSTS,
} from "../actions/constant";

const initialState = {
  symptomsList: [],
  postsList: [],
  allPosts: [],
  archivePosts: [],
  forumPosts: [],
  langList: [],
  allArchivePosts: [],
  sortByList: [
    { value: "relevancy", label: "Relevance" },
    { value: "Most Recent", label: "Most Recent" },
  ],
  isLoading: true,
  disabled: {
    shareButton: true,
    publishButton: true,
  },
  forumFiltersForm: { symptom: "", sortBy: "", lang: "" },
  saveSuccess: false,
  counterState: 0,
  firstChange: false,
  relevantFailed: false,
  editMode: false,
  filteredPosts: [],
  selectedPosts: [],
  changeSymptomWithoutSaveDraftPost: false,
  changeSymptomWithoutSavePost: false,
};

function unsavedDataChecker(is_unsaved, post_type) {
  let vAlertMessages = {};
  if (post_type === "new_post") {
    vAlertMessages = {
      title: i18n.t("forum.UNSAVED_NEW_POST_TITLE"),
      text: i18n.t("forum.UNSAVED_NEW_POST_TEXT_2"),
      logout_text: i18n.t("forum.UNSAVED_NEW_POST_TEXT"),
      positiveBtnText: i18n.t("general.POSITIVE_PROMPT_TEXT"),
    };
  } else if (post_type === "existing_published") {
    vAlertMessages = {
      title: i18n.t("forum.UNSAVED_EDIT_POST_TITLE"),
      text: i18n.t("forum.UNSAVED_EDIT_POST_TEXT_2"),
      logout_text: i18n.t("forum.UNSAVED_EDIT_POST_TEXT"),
      positiveBtnText: i18n.t("general.POSITIVE_PROMPT_TEXT"),
    };
  } else if (post_type === "existing_draft") {
    vAlertMessages = {
      title: i18n.t("forum.UNSAVED_EDIT_DRAFT_TITLE"),
      text: i18n.t("forum.UNSAVED_EDIT_DRAFT_TEXT_2"),
      logout_text: i18n.t("forum.UNSAVED_EDIT_DRAFT_TEXT"),
      positiveBtnText: i18n.t("general.POSITIVE_PROMPT_TEXT"),
    };
  }
  if (is_unsaved) {
    IS_UNSAVED("yes");
    localStorage.setItem("unsavedAlertData", JSON.stringify(vAlertMessages));
  } else {
    IS_UNSAVED("no");
    localStorage.removeItem("unsavedAlertData");
  }
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case getStarted(FORUM_SINGLE_INITIALIZATION):
      return { ...state, isLoading: true };
    case getSucceeded(FORUM_SINGLE_INITIALIZATION):
      if (action.payload && action.payload.publish_status !== "irelevant") {
        IS_UNSAVED("no");
      }
      return {
        ...state,
        singlePostItem: action.payload,
      };
    case getFailed(FORUM_SINGLE_INITIALIZATION):
      return { ...state, saveFailed: true, isLoading: false };
    case getEnded(FORUM_SINGLE_INITIALIZATION):
      return { ...state, isLoading: false };
    case getStarted(FORUM_INITIALIZATION):
      state.forumFiltersForm.search = "";
      state.forumFiltersForm.sortBy = state.sortByList[1].value;
      return {
        ...state,
        isLoading: true,
        draftModal: false,
        updateDraftModel: false,
        publishModal: false,
        postUpdated: false,
      };
    case getSucceeded(FORUM_INITIALIZATION):
      forumSymptom = action.payload.forumSymptom;
      pageMode = action.payload.pageMode;
      let postsList = action.payload.data;
      let langList = [];
      if (action.payload.langList) {
        USER_LANG.map((item) => {
          for (let index = 0; index < action.payload.langList.length; index++) {
            if (item.value == action.payload.langList[index]) {
              langList.push({
                label: item.label,
                value: item.value,
              });
            }
          }
        });
      }
      IS_UNSAVED("no");
      let allSymptoms =
        action.payload.symptomsList &&
        action.payload.symptomsList.length > 0 &&
        action.payload.symptomsList.sort((a, b) =>
          a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1
        );
      state.forumFiltersForm = {
        ...state.forumFiltersForm,
        symptom:
          pageMode && pageMode === "mine" && forumSymptom
            ? forumSymptom
            : action.payload.symptomId
              ? action.payload.symptomId
              : "",
        // symptom: state.symptomCat,
        _id: "",
        body: "",
        search: "",
        sortBy: "Most Recent",
        lang: pageMode && pageMode === "user" ? null : action.payload.userLang,
      };
      if (postsList.data && pageMode === "mine") {
        postsList.data = postsList.data.sort((x, y) => {
          let x_date = x.date;
          let y_date = y.date;
          if (x.draft_at !== undefined && x.draft_at !== "") {
            x_date = x.draft_at;
          }
          if (y.draft_at !== undefined && y.draft_at !== "") {
            y_date = y.draft_at;
          }
          return y_date - x_date;
        });
      }

      return {
        ...state,
        symptomsList: allSymptoms,
        postsList: postsList,
        allPosts: postsList,
        forumPosts: postsList,
        langList,
        changeSymptomWithoutSaveDraftPost: false,
        changeSymptomWithoutSavePost: false,
        pageMode: pageMode,
      };
    case getFailed(FORUM_INITIALIZATION):
      return { ...state, saveFailed: true, isLoading: false };
    case getEnded(FORUM_INITIALIZATION):
      state.forumFiltersForm.body = "";
      if (state.postsList.data) {
        state.postsList.data = state.postsList.data.sort((x, y) => {
          let x_date = x.date;
          let y_date = y.date;
          if (state.pageMode === "mine") {
            if (x.draft_at !== undefined && x.draft_at !== "") {
              x_date = x.draft_at;
            }
            if (y.draft_at !== undefined && y.draft_at !== "") {
              y_date = y.draft_at;
            }
          }
          return y_date - x_date;
        });
      } else {
        state.postsList = state.postsList.sort((x, y) => {
          let x_date = x.date;
          let y_date = y.date;
          if (state.pageMode === "mine") {
            if (x.draft_at !== undefined && x.draft_at !== "") {
              x_date = x.draft_at;
            }
            if (y.draft_at !== undefined && y.draft_at !== "") {
              y_date = y.draft_at;
            }
          }
          return y_date - x_date;
        });
        state.postsList = state.postsList.filter((item) => {
          return item.lang === state.forumFiltersForm.lang;
        });
      }
      return { ...state, isLoading: false };
    case getStarted(FORUM_ARCHIVE_INITIALIZATION):
      if (!action.payload.langList) {
        USER_LANG.map((item) => {
          state.langList.push({
            label: item.label,
            value: item.value,
          });
        });
      }
      state.forumFiltersForm._id = "";
      state.forumFiltersForm.body = "";
      return {
        ...state,
        doArchiveValertStatus: false,
        isLoading: true,
        draftModal: false,
        updateDraftModel: false,
        publishModal: false,
        postUpdated: false,
        relevantFailed: false,
        editMode: false,
      };

    case getSucceeded(FORUM_ARCHIVE_INITIALIZATION):
      let forumSymptom = action.payload.forumSymptom;
      let pageMode = action.payload.pageMode;
      langList = [];
      if (action.payload.langList) {
        USER_LANG.map((item) => {
          for (let index = 0; index < action.payload.langList.length; index++) {
            if (item.value == action.payload.langList[index]) {
              langList.push({
                label: item.label,
                value: item.value,
              });
            }
          }
        });
      }
      var lisOfSymptoms = [];
      if (
        action.payload.symptomsList &&
        action.payload.symptomsList.length > 0
      ) {
        lisOfSymptoms = [...action.payload.symptomsList];
      }
      let singlePost = [];
      let allArchivePosts = action.payload.data;
      let langId = action.payload.userLang;
      if (action.payload.singlePostId) {
        singlePost = allArchivePosts.filter((item) => {
          return item._id == action.payload.singlePostId;
        });

        langId = singlePost[0].lang;
        
      }

      const newArchivePosts = allArchivePosts.filter(item => {

        if (item.lang !== langId) return false;

        if (action.payload.singlePostId) {
          return item._id !== action.payload.singlePostId;
        }

        return true;
      });
console.log(allArchivePosts)

      archivePosts = _.orderBy(
        newArchivePosts,
        [(item) => Number(item.date)],
        ["desc"]
      );
      state.userLang = langId;
      lisOfSymptoms.sort((a, b) =>
        a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1
      );
      if (action.payload.singlePostId) {
        archivePosts.unshift(...singlePost);
      }
      return {
        ...state,
        isLoading: false,
        symptomsList: lisOfSymptoms,
        allPosts: archivePosts,
        archivePosts: archivePosts,
        allArchivePosts: allArchivePosts,
        forumFiltersForm: {
          ...state.forumFiltersForm,
          symptom:
            pageMode &&
              pageMode === "mine" &&
              forumSymptom &&
              forumSymptom !== "null"
              ? forumSymptom
              : action.payload.symptomId,
          _id: "",
          body: "",
          search: "",
          sortBy: "Most Recent",
          lang: langId,
        },
        langList,
        changeSymptomWithoutSaveDrafdPost: false,
        changeSymptomWithoutSavePost: false,
        updateSymptomWithoutSavePost: false,
      };
    case getStarted(FORUM_RELEVANT):
      return { ...state, isLoading: true };
    case getStarted(FORUM_INSERT):
      return { ...state, isLoading: true };
    case getSucceeded(FORUM_INSERT):
      state.editMode = false;
      let updateDraftModel = state.forumFiltersForm.draft;
      state.forumFiltersForm.body = "";
      state.forumFiltersForm.draft = "";
      state.disabled.publishButton = true;
      if (action.payload.draft) {
        state.draftModal = true;
        state.updateDraftModel = updateDraftModel;
      } else {
        state.publishModal = true;
      }
      return { ...state, isLoading: true /*saveSuccess: true */ };
    case getFailed(FORUM_INSERT):
      return { ...state, saveFailed: true };
    case getEnded(FORUM_INSERT):
      return { ...state, isLoading: false };
    case getStarted(ON_CHANGE_FORUM_FILTERS):
      return { ...state, isLoading: true };
    case getSucceeded(ON_CHANGE_FORUM_FILTERS):
      const { name, value, pageName, userLang } = action.payload;
      let forumPosts =
        pageName === "forumMe" ? state.postsList : state.forumPosts;
      if (name != "body" && action.payload.pageMode != "user") {
        state.postsList = action.payload.data;
        state.forumPosts = action.payload.data;
        forumPosts = action.payload.data;
      }
      if (name != "body") {
        state.forumFiltersForm._id = "";
        state.forumFiltersForm.body = "";
        state.editMode = false;
      }
      if (name != "search") {
        state.selectedPosts = [];
      } else {
        state.postsList.data.forEach(function (item, index) {
          const exists = state.selectedPosts.some(post => post._id === item._id);
          if (exists) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        });
      }
      if (name === "symptom") {
        state.forumFiltersForm = {
          ...state.forumFiltersForm,
          draft: false,
          search: "",
          lang: userLang,
          sortBy: "Most Recent",
        };
        state.changeSymptomWithoutSaveDraftPost = false;
        state.changeSymptomWithoutSavePost = false;
        state.disabled.publishButton = true;
        state.forumPosts = action.payload.data;
        state.allPosts = action.payload.data;
        state.selectedPosts = [];
        state.selectedPost = "";
        if (action.payload.pageMode === "user") {
          forumPosts = {
            ...action.payload.data,
            data: action.payload.data.data.filter(
              (item) =>
                item.draft !== true ||
                (item.draft === true && item.publish_status === "republishing")
            ),
          };
        }
      }
      const { selectedPost } = state;
      state.forumFiltersForm[name] = value;
      if (pageName === "forumMe") {
        if (!_.isEmpty(selectedPost)) {
          if (selectedPost.draft) {
            state.changeSymptomWithoutSaveDraftPost = true;
            state.changeSymptomWithoutSavePost = false;
          } else {
            state.changeSymptomWithoutSaveDraftPost = false;
            state.changeSymptomWithoutSavePost = true;
          }
        } else {
          if (value) {
            state.changeSymptomWithoutSaveDraftPost = false;
            state.changeSymptomWithoutSavePost = false;
          }
        }
        if (value.length >= 5 && name === "body") {
          if (state.editMode) {
            if (
              selectedPost.body !== value ||
              selectedPost.publish_status === "draft" ||
              selectedPost.publish_status === "republishing"
            ) {
              state.disabled.publishButton = false;
            } else if (selectedPost.body === value) {
              state.disabled.publishButton = true;
            }
          } else {
            state.disabled.publishButton = false;
          }
        } else {
          state.disabled.publishButton = true;
        }
      }
      if (!state.editMode && state.forumFiltersForm.body) {
        unsavedDataChecker(true, "new_post");
      } else if (
        state.editMode &&
        state.forumFiltersForm.body !== state.selectedPost.body
      ) {
        if (!state.selectedPost.draft) {
          unsavedDataChecker(true, "existing_published");
        } else {
          unsavedDataChecker(true, "existing_draft");
        }
      }
      if (!state.forumFiltersForm.body) {
        state.postUpdated = false;
      }
      if (state.forumFiltersForm.sortBy !== "relevancy") {
        forumPosts.data = forumPosts.data.sort((x, y) => {
          let x_date = x.date;
          let y_date = y.date;
          if (action.payload.pageMode === "mine") {
            if (x.draft_at !== undefined && x.draft_at !== "") {
              x_date = x.draft_at;
            }
            if (y.draft_at !== undefined && y.draft_at !== "") {
              y_date = y.draft_at;
            }
          }
          return y_date - x_date;
        });
      }
      if ((!state.editMode &&
        state.forumFiltersForm.body === "") || (state.editMode &&
          state.forumFiltersForm.body == state.selectedPost.body)) {
        IS_UNSAVED("no")
      } else {
        IS_UNSAVED("yes")
      }
      return {
        ...state,
        postsList: forumPosts,
        name: action.payload.name,
        value: action.payload.value,
        counterState: state.counterState + 1,
      };
    case getEnded(ON_CHANGE_FORUM_FILTERS):
      return { ...state, isLoading: false };
    case RE_GET_FORUM_FILTERS:
      state.postsList = action.data;
      return {
        ...state,
        counterState: state.counterState + 1,
      };
    case FORUM_SELECT_FOR_EDIT_POST:
      state.postsList.data.forEach(function (item, index) {
        if (action.typeOfSelect || action.typeOfSelect === "multiple") {
          if (item._id == action.postId) {
            item.selected = !item.selected;
            state.symptomCat = item.symptom;
            if (item.selected) {
              const exists = state.selectedPosts.some(post => post._id === item._id);
              if (!exists) {
                state.selectedPosts.push(item);
              }
            } else {
              state.selectedPosts = state.selectedPosts.filter(post => post._id !== item._id);
            }
          }
        } else {
          if (item._id == action.postId) {
            //item.selected = !item.selected;

            if (item.selected) {
              state.forumFiltersForm._id = "";
              state.forumFiltersForm.body = "";
              state.forumFiltersForm.updateSymptom = "";
              item.selected = false;
              state.editMode = false;
              state.forumFiltersForm.draft = false;
              state.forumFiltersForm.selectedItem = "";
              state.selectedPost = {};
              state.disabled.publishButton = true;
              IS_UNSAVED("no");
              localStorage.removeItem("unsavedAlertData");
            } else {
              state.forumFiltersForm._id = item._id;
              state.forumFiltersForm.body = item.body;
              state.forumFiltersForm.updateSymptom = item.symptom;
              state.forumFiltersForm.draft = item.draft;
              item.selected = true;
              state.editMode = true;
              state.forumFiltersForm.selectedItem = index;
              state.symptomCat = item.symptom;
              state.selectedPost = item;
              if (
                (item.draft || item.publish_status === "draft") &&
                item.body.length >= 5
              ) {
                state.disabled.publishButton = false;
              } else {
                state.disabled.publishButton = true;
              }
            }
          } else {
            IS_UNSAVED("no");
            localStorage.removeItem("unsavedAlertData");
            item.selected = false;
          }
        }
      });
      state.changeSymptomWithoutSaveDraftPost = false;
      state.changeSymptomWithoutSavePost = false;
      return {
        ...state,
        counterState: state.counterState + 1,
      };
    case getStarted(FORUM_RELEVANT):
      return { ...state, isLoading: true };
    case getSucceeded(FORUM_RELEVANT):
      state.postsList.data.forEach((item) => {
        if (item._id == action.payload[0]._id) {
          item.relevant.up = action.payload[0].relevant.up;
          item.relevant.down = action.payload[0].relevant.down;
        }
      });
      return { ...state };
    case getFailed(FORUM_RELEVANT):
      return {
        ...state,
        relevantFailed: true,
        counterState: state.counterState + 1,
      };
    case getEnded(FORUM_RELEVANT):
      return { ...state, isLoading: false };
    case FORUM_REMOVE_ARCHIVE:
      let deleteIndex = undefined;
      state.allArchivePosts.forEach((item, i) => {
        if (item._id == action.postId) {
          return (deleteIndex = i);
        }
      });
      state.archivePosts = state.archivePosts.filter(
        (post) => post._id !== action.postId
      );
      state.allArchivePosts.splice(deleteIndex, 1);
      state.allPosts.splice(deleteIndex, 1);
      return { ...state, counterState: state.counterState + 1 };
    case FORUM_ON_CHANGE_STATE:
      state[action.name] = action.value;
      return {
        ...state,
        counterState: state.counterState + 1,
      };
    case getStarted(FORUM_DELETE_POST):
      return { ...state, isLoading: true };
    case getSucceeded(FORUM_DELETE_POST):
      state.forumFiltersForm.body = "";
      state.postsList.data.forEach((item, i) => {
        if (item._id == action.payload._id) {
          deleteIndex = i;
        }
      });
      if (deleteIndex != undefined) state.postsList.data.splice(deleteIndex, 1);
      state.postsList.data.forEach(function (item, index) {
        item.selected = false;
        state.forumFiltersForm._id = "";
        state.forumFiltersForm.body = "";
        state.forumFiltersForm.updateSymptom = "";
        item.selected = false;
        state.editMode = false;
        state.forumFiltersForm.selectedItem = "";
        state.selectedPost = {};
        state.editMode = false;
        state.forumFiltersForm.draft = "";
        state.disabled.publishButton = true;
      });

      unsavedDataChecker(false);
      return { ...state };
    case getFailed(FORUM_DELETE_POST):
      return {
        ...state,
      };
    case getEnded(FORUM_DELETE_POST):
      return {
        ...state,
        isLoading: false,
        counterState: state.counterState + 1,
      };
    case getStarted(FORUM_DO_ARCHIVE):
      return { ...state, isLoading: true };
    case getSucceeded(FORUM_DO_ARCHIVE):
      state.postsList.data.forEach((item, i) => {
        item.selected = false;
      });
      // setTimeout(() => {
      //   window.location.href = `/forum/archive`;
      // }, 1000);
      return { ...state, doArchiveValertStatus: true, saveSuccess: true };
    case getFailed(FORUM_DO_ARCHIVE):
      return {
        ...state,
      };
    case getEnded(FORUM_DO_ARCHIVE):
      return {
        ...state,
        isLoading: false,
        counterState: state.counterState + 1,
      };
    case FORUM_CANCEL_POST:
      IS_UNSAVED("no");
      state.forumFiltersForm._id = "";
      state.forumFiltersForm.body = "";
      state.editMode = false;
      state.changeSymptomWithoutSavePost = false;
      state.disabled.publishButton = true;
      state.selectedPost = {};
      return { ...state, counterState: state.counterState + 1 };

    case getSucceeded(FORUM_LOAD_MORE):
      let oldData = { ...state.postsList };
      let newData = action.payload;
      newData.data = oldData.data.concat(newData.data);
      state.postsList = newData;
      state.forumPosts = newData;
      if (state.forumFiltersForm.sortBy !== "relevancy") {
        state.forumPosts.data = state.forumPosts.data.sort((x, y) => {
          let x_date = x.date;
          let y_date = y.date;
          if (state.pageMode === "mine") {
            if (x.draft_at !== undefined && x.draft_at !== "") {
              x_date = x.draft_at;
            }
            if (y.draft_at !== undefined && y.draft_at !== "") {
              y_date = y.draft_at;
            }
          }
          return y_date - x_date;
        });
      }
      return { ...state };
    case getStarted(ON_CHANGE_ARCHIVE_FILTERS):
      return { ...state, isLoading: true };
    case getSucceeded(ON_CHANGE_ARCHIVE_FILTERS):
      state.forumFiltersForm[action.payload.name] = action.payload.value;
      const { lang, search, symptom, sortBy } = state.forumFiltersForm;
      let archivePosts = [...state.allArchivePosts];

      if (action.payload.name === "symptom") {
        state.forumFiltersForm.sortBy = "Most Recent";
        state.forumFiltersForm.lang = action.payload.userLang;
        state.forumFiltersForm.search = "";
      }

      if (
        state.forumFiltersForm.lang !== null &&
        state.forumFiltersForm.lang !== ""
      ) {
        archivePosts = archivePosts.filter((item) => {
          return item.lang === state.forumFiltersForm.lang;
        });
      }

      if (symptom !== undefined && symptom !== "") {
        archivePosts = archivePosts.filter((item) => {
          return item.symptom === symptom;
        });
      }
      if (state.forumFiltersForm.search !== "") {
        let searchExpression = new RegExp(
          `(${_.escapeRegExp(state.forumFiltersForm.search)})`,
          "i"
        );
        archivePosts = archivePosts.filter((item) => {
          return (
            item.body &&
            item.body
              .toLowerCase()
              .replace(/\s+/g, "")
              .includes(search.toLowerCase().replace(/\s+/g, ""))
          );
        });
        archivePosts = archivePosts.map((item) => {
          let searchResult = item.body.search(searchExpression);
          return searchResult > -1 && item;
        });
      }
      if (state.forumFiltersForm.sortBy !== "Most Recent") {
        archivePosts = _.orderBy(
          archivePosts,
          ["relevant.order", "date"],
          ["desc", "desc"]
        );
      } else {
        archivePosts = _.orderBy(archivePosts, ["date"], ["desc"]);
        state.forumFiltersForm.sortBy = "Most Recent";
      }

      return {
        ...state,
        archivePosts,
        counterState: state.counterState + 1,
        name: action.payload.name,
        value: action.payload.value,
      };
    case getEnded(ON_CHANGE_ARCHIVE_FILTERS):
      return { ...state, isLoading: false };
    case ON_SEARCH_POSTS:
      state.forumFiltersForm.search = action.value;
      return {
        ...state,
      };
    case CLEAR_FORUM:
      return {
        ...state,
        publishModal: false,
        saveSuccess: false,
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/forumReducer.js